import React, { useState, useEffect, useRef } from "react";
import { useDataManagement } from "../ferramentas/RequisitarAPI.ts";
import style from './ModalStyles.module.css';
import ToastMessage from "../ferramentas/toastMessage/ToastMessage";
import Placeholder from "../ferramentas/placeholder/Placeholder.js";
import makeAnimated from 'react-select/animated';

const UsersManage = ({ onClose, onSave }) => {
    const { users: usersAPI, load } = useDataManagement();
    const modalContentRef = useRef(null);
    const [userOptions, setUserOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const animatedComponents = makeAnimated();

    useEffect(() => {
        async function loadUsers() {
            const result = await usersAPI.list();
            if (result.ok) {
                const formattedUsers = Object.values(result.data)
                    .filter(user => user.active)
                    .map((user) => ({
                        value: user,
                        label: user.fullname,
                    }));
                setUserOptions(formattedUsers);
            }
        }
        loadUsers();
    }, [usersAPI]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalContentRef.current && !modalContentRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    const handleUserSelection = (selectedOption) => {
        setSelectedUser(selectedOption);
    };

    const handleSubmit = async () => {
        if (!selectedUser?.value?.id) {
            ToastMessage({ cod: "w", texto: "Por favor, selecione um usuário." });
            return;
        }
        onSave(selectedUser.value.id);
    };

    return (
        <div className={style.modal} onClick={onClose}>
            {/* Adicionando a classe para aumentar a altura mínima do modal */}
            <div 
              className={`${style.modal_content} ${style.modal_content_tall}`} 
              ref={modalContentRef} 
              onClick={(e) => e.stopPropagation()}
            >
                <div className={style.modalHeader}>
                    <h2>Inativar Usuário</h2>
                    <span className={style.close} onClick={onClose}>×</span>
                </div>

                <div className={style.modalBody}>
                    <p className={style.formSectionDescription}>
                        Selecione o usuário que deseja inativar. A conta será desativada e o usuário perderá o acesso ao sistema.
                    </p>
                    
                    <div className={`${style.formGroup} ${style.select}`}>
                        <Placeholder
                            type="select"
                            id="user-select"
                            name="user"
                            components={animatedComponents}
                            options={userOptions}
                            onChange={handleUserSelection}
                            value={selectedUser}
                            isLoading={load.isLoading}
                            classNamePrefix="user"
                            className={style.select}
                        />
                    </div>

                    {selectedUser && (
                        <div className={style.userInfoCard}>
                            <h4 className={style.userInfoName}>{selectedUser.label}</h4>
                            <div className={style.userInfoDetail}>
                                <span className={style.detailIcon}>📧</span>
                                <a href={`mailto:${selectedUser.value.email}`}>{selectedUser.value.email}</a>
                            </div>
                            <div className={style.userInfoDetail}>
                                <span className={style.detailIcon}>📞</span>
                                <span>{selectedUser.value.phone}</span>
                            </div>
                        </div>
                    )}
                </div>

                <div className={style.modalFooter}>
                    <button className={`${style.modalButton} ${style.cancelButton}`} type="button" onClick={onClose}>
                        Cancelar
                    </button>
                    <button
                        className={`${style.modalButton} ${style.deleteButton}`}
                        type="button"
                        onClick={handleSubmit}
                        disabled={!selectedUser}
                    >
                        Inativar Usuário
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UsersManage;